import {CACHE_KEY, fetchHash} from './AutoUpdater';

/** Additional code for checking if a new version is available.
 * This is *not* supposed to replace "AutoUpdater", but used on some
 * important pages' mount, to check if a new version is available.
 * This function does not take the "cache" into account on purpose.
 */
export const checkIfNewVersionAvailable = async (): Promise<boolean> => {
  const newHash = await fetchHash('/build-info.json');
  if (!newHash) return false;

  const existingHash = localStorage.getItem(CACHE_KEY) ?? '';

  const newVersionAvailable = existingHash !== newHash;

  if (newVersionAvailable) {
    console.log(
      `checkIfNewVersionAvailable: new version available (${existingHash} vs ${newHash})`,
    );
    localStorage.setItem(CACHE_KEY, newHash);
  } else {
    console.log(
      `checkIfNewVersionAvailable: no new version available (${existingHash})`,
    );
  }

  return newVersionAvailable;
};
